import { render, staticRenderFns } from "./SunAltitudeChart.vue?vue&type=template&id=580d0c16"
import script from "./SunAltitudeChart.vue?vue&type=script&lang=js"
export * from "./SunAltitudeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports